import {
  PushNotifications,
  ActionPerformed,
} from '@capacitor/push-notifications';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Capacitor } from '@capacitor/core';
import { RequestService } from '../request/request.service';
import { HttpClient } from '@angular/common/http';
import { EnvService } from '../env/env.service';
import { AuthService } from '../auth/auth.service';

@Injectable({
  providedIn: 'root',
})
export class PushNotifService {
  constructor(
    private router: Router,
    private req: RequestService,
    public http: HttpClient,
    public env: EnvService,
    public authService: AuthService
  ) {}

  initPushNotif() {
    this.checkPermission();
    this.registerPushNotif();
  }

  async checkPermission() {
    // await PushNotifications.requestPermissions();

    let permstat = await PushNotifications.checkPermissions();

    if (permstat.receive === 'prompt') {
      await PushNotifications.requestPermissions();
    }

    if (permstat.receive !== 'granted') {
      console.error('Permission Denied !');
    }

    await PushNotifications.register();
  }

  async registerPushNotif() {
    PushNotifications.addListener('registration', (token) => {
      // localStorage.setItem('currentFCMToken', token.value);
      // this.authService.currentFCMTokenSubject.next(token.value);

      if (this.authService.currentTokenValue != null) {
        let formData = {
          fcm_token: token.value,
        };

        this.http
          .post(this.env.url_public + 'fcm-token', formData)
          .subscribe((res) => {});
      }
    });

    await PushNotifications.addListener('registrationError', (err) => {});

    await PushNotifications.addListener(
      'pushNotificationReceived',
      (notification) => {
        if (
          typeof notification.title != 'undefined' &&
          typeof notification.body != 'undefined'
        ) {
          if (Capacitor.getPlatform() === 'android') {
            if (
              typeof notification.data.notification_toaster == 'undefined' ||
              (typeof notification.data.notification_toaster != 'undefined' &&
                notification.data.notification_toaster != '0')
            ) {
            }
          }
        }
      }
    );

    await PushNotifications.addListener(
      'pushNotificationActionPerformed',
      (notification) => {
        this.router.navigate([notification.notification.data.redirect]);
      }
    );
  }

  resetBadgeCount() {
    PushNotifications.removeAllDeliveredNotifications();
  }
}
